import { useUDData } from '@udemy/ud-data';
export function useIsFeatureEnabled() {
  const {
    Config
  } = useUDData();
  function isFeatureEnabled(featureName) {
    const findKey = ([first, ...rest], hashmap = Config.features) => {
      if (rest.length === 0) {
        return hashmap[first] || false;
      }
      return hashmap && first ? findKey(rest, hashmap[first]) : false;
    };
    return findKey(featureName.split('.'));
  }
  return isFeatureEnabled;
}
//# sourceMappingURL=use-is-feature-enabled.js.map